const useDragEnd = () => {
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result, data, fieldName, setFieldValue) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const orderedNodes = reorder(data, result.source.index, result.destination.index);

        setFieldValue(fieldName, orderedNodes);
    };

    const handleRemove = (id, values, fieldName, setFieldValue) => {
        let dataValues = [...values];
        dataValues.splice(id, 1);
        setFieldValue(fieldName, dataValues);
    };

    return [onDragEnd, handleRemove];
};

export { useDragEnd };
